module.exports = __webpack_public_path__ + "static/united-states-855f8bfbbde42bd0e60a903a21ae97d8.png";